import { Injectable } from "@angular/core";
import { ProfileDetialsModel } from "@app/models/ProfileDetailsModel";
import { ProfileDetailsEndPoint } from "@app/services/customerProfile/profile-details-endpoint.service";
import { Subscription } from "rxjs";
import { Observable } from "rxjs/Observable";
import { Country } from "@app/common/app-enum";

@Injectable()
export class ProfileDetailsService{
    private refreshValueTypeClientSubscription: Subscription;

    constructor(private profileDetailsEndPoint : ProfileDetailsEndPoint
    ){
    }
   
    updateCustomerProfileDetails(profileDetails: ProfileDetialsModel){
        
        return this.profileDetailsEndPoint.updateCustomerProfileDetails(profileDetails);
    }

    
    getUserData(){
        return this.profileDetailsEndPoint.getUserData();
    }

    getUserMerchantData(){
        return this.profileDetailsEndPoint.getUserMerchantData();
    }
    getMerchantDetails(EntityId:number){
        return this.profileDetailsEndPoint.getMerchantDetails(EntityId);
    }

    getLocationData(id: number){
        
        return this.profileDetailsEndPoint.getLocationData(id);
    }
    getCityData(stateId: number){
        
        return this.profileDetailsEndPoint.getCityData(stateId);
    }
    getRegistrationNumber(){
        return this.profileDetailsEndPoint.getRegistrationNumber();
    }
}


// WEBPACK FOOTER //
// ./src/app/services/customerProfile/profile-details.service.ts